import { useState, useEffect } from "react";
import { Dropdown } from "react-bootstrap";
import { Palette } from "lucide-react";

const themes = [
  { id: "teal", name: "Verde Água", primary: "#0d9488", secondary: "#14b8a6" },
  { id: "purple", name: "Roxo", primary: "#7c3aed", secondary: "#8b5cf6" },
  { id: "blue", name: "Azul", primary: "#2563eb", secondary: "#3b82f6" },
  { id: "pink", name: "Rosa", primary: "#db2777", secondary: "#ec4899" },
  { id: "orange", name: "Laranja", primary: "#ea580c", secondary: "#f97316" },
  { id: "green", name: "Verde", primary: "#16a34a", secondary: "#22c55e" },
];

const ThemeSwitcher = () => {
  const [currentTheme, setCurrentTheme] = useState("teal");

  useEffect(() => {
    const savedTheme = localStorage.getItem("theme-color");
    if (savedTheme) {
      setCurrentTheme(savedTheme);
      applyTheme(savedTheme);
    }
  }, []);

  const applyTheme = (themeId) => {
    const theme = themes.find((t) => t.id === themeId);
    if (theme) {
      document.documentElement.style.setProperty("--theme-primary", theme.primary);
      document.documentElement.style.setProperty("--theme-secondary", theme.secondary);
    }
  };

  const handleThemeChange = (themeId) => {
    setCurrentTheme(themeId);
    localStorage.setItem("theme-color", themeId);
    applyTheme(themeId);
  };

  const currentThemeData = themes.find((t) => t.id === currentTheme);

  return (
    <Dropdown>
      <Dropdown.Toggle
        variant="link"
        className="p-2 text-decoration-none d-flex align-items-center gap-2"
        style={{ color: "var(--theme-primary)" }}
      >
        <Palette size={20} />
      </Dropdown.Toggle>
      <Dropdown.Menu align="end" className="shadow-card border-0 p-2" style={{ minWidth: "160px" }}>
        <div className="px-2 py-1 mb-2">
          <small className="text-muted fw-semibold">Cor do Tema</small>
        </div>
        {themes.map((theme) => (
          <Dropdown.Item
            key={theme.id}
            onClick={() => handleThemeChange(theme.id)}
            className={`d-flex align-items-center gap-2 rounded ${currentTheme === theme.id ? "active" : ""}`}
          >
            <span
              className="d-inline-block rounded-circle"
              style={{
                width: "16px",
                height: "16px",
                background: `linear-gradient(135deg, ${theme.primary} 0%, ${theme.secondary} 100%)`,
              }}
            />
            {theme.name}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ThemeSwitcher;